import React, { Component } from 'react';
import './content.scss';
import { ReactComponent as IncrementIcon } from '../Images/increment-icon-gray.svg';
import { ReactComponent as DecrementIcon } from '../Images/decrement-icon-gray.svg';
import { ReactComponent as IncrementIconWhite } from '../Images/increment-icon-white.svg';
import { ReactComponent as DecrementIconWhite } from '../Images/decrement-icon-white.svg';
import { ReactComponent as RequiredChecked } from '../../../assets/images/icons/required-checked.svg';
import { ReactComponent as AccordionOpenIcon } from '../../../assets/images/accordion-open.svg';
import Accordion from 'react-bootstrap/Accordion';
import { PiBowlFoodFill } from 'react-icons/pi';
import { RiCloseCircleFill } from 'react-icons/ri';

export default class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAccordionKey: 0,
    };
  }

  openNextAccordion = accordionIndex => {
    this.setState({ currentAccordionKey: accordionIndex + 1 });
  };

  showSelectedItems = itemList => {
    let selectedItems = [];
    itemList.map((item, index) => {
      if (item.selectedQty > 0) {
        selectedItems.push(item.itemName);
      }
    });

    return <span>{selectedItems.join(', ')}</span>;
  };

  render() {
    const { populateItemImage, selectedItem, populateModifierItem, incDecItem, calculateItemTotal, checkIfBtnIsDisabled, proceedBtnClick, closeModifierModal } = this.props;
    let getFNBItemImage = selectedItem.hasOwnProperty('fnbs_images') && selectedItem.fnbs_images.length > 0 ? selectedItem.fnbs_images[0].imageurl : '';
    return (
      <React.Fragment>
        <div className="imageContainer">{populateItemImage()}</div>
        <div className="fnbItemDetailsContainer">
          <div className="modifierHeader">
            <img src={getFNBItemImage} alt={selectedItem.itemName} width="245" height="auto" />
            <div className="headerContent">
              <p className="fnbItemName">{selectedItem.itemName}</p>
              {selectedItem.itemDetails && <p className="fnbItemDescription">{selectedItem.itemDetails}</p>}
            </div>
            <div className="headerPriceCart">
              <p>${calculateItemTotal().price}</p>
              <div className="incDec">
                <div className="incDecButtonDiv">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary decButton borderTopRadiusZero ${selectedItem.selectedQty == 1 ? 'disabled' : ''}`}
                    onClick={() => incDecItem('subtract', '')}
                  >
                    <DecrementIconWhite className="" />
                  </button>
                  <span className="selectedQty">{selectedItem.selectedQty}</span>
                  <button type="button" className={`btn btn-outline-secondary incButton borderBottomRadiusZero ${selectedItem.addBtnDisabled || selectedItem.selectedQty >= selectedItem.maximumqty ? 'disabled' : ''}`} onClick={() => incDecItem('add', '')}>
                    <IncrementIconWhite className="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mod-blk">
            <p className="modifierTitle">MAKE YOUR SELECTIONS</p>

            {selectedItem.fnbs_alternateitems.length > 0 ? (
              <div className="modifierGroupDiv select-option-blk">
                <p className="modiferGroupName">Select an option</p>
                <div key={`inline-alternateItem-div`} className="select-option-items d-flex" style={{ flexWrap: 'wrap' }}>
                  {selectedItem.fnbs_alternateitems.map((alternateItem, alternateItemIndex) => {
                    return populateModifierItem('alternateItem', '', alternateItem, alternateItemIndex);
                  })}
                </div>
              </div>
            ) : (
              <></>
            )}

            {(() => {
              const visibleGroups = (selectedItem.modifierGroups || []).filter(g => !(g.minQty > 0 && g.maxQty < g.minQty));
              return visibleGroups.length > 0 && (
                <Accordion className="modifierGroupsAccordionWrapper" activeKey={this.state.currentAccordionKey} onSelect={eventKey => this.setState({ currentAccordionKey: eventKey })}>
                  {visibleGroups.map((modifierGroup, modifierGroupIndex) => {
                    let modifierItemsSelected = 0;
                    modifierGroup.modifier_items.reduce((acc, item) => {
                      if (item.selectedQty > 0) {
                        modifierItemsSelected += item.selectedQty;
                      }
                      return acc;
                    }, 0);
                    return (
                      <Accordion.Item className="modifierGroupDiv required-optional-blk" eventKey={modifierGroupIndex}>
                        <Accordion.Header className="modiferGroupName">
                          <div>
                            <p className={modifierGroup.minQty > 0 ? 'required' : ''}>
                              {modifierGroup.tabName}
                              {modifierGroup.minQty == 0 && modifierItemsSelected == 0 ? (
                                <ul className="optional">
                                  <li className="pointOne">Optional</li>
                                  {
                                    modifierGroup.freeQty > 0 &&
                                    <>
                                      <span className="redDot"></span>
                                      <li className="pointThree">Choose any and get {modifierGroup.freeQty} Qty. free</li>
                                    </>
                                  }
                                  {modifierGroup.maxQty > 0 ? (
                                    <>
                                      <span className="optionalDot"></span>
                                      <li className="pointThree">{modifierGroup.maxQty > 1 ? `Make up to ${modifierGroup.maxQty} selections` : `Make ${modifierGroup.maxQty} selection`} </li>
                                    </>
                                  ) : null}
                                </ul>
                              ) : null}
                              {modifierItemsSelected < modifierGroup.minQty ? (
                                <ul>
                                  <li className="pointOne">Required</li>
                                  <span className="redDot"></span>
                                  <li className="pointThree">{modifierGroup.maxQty > 1 ? `Make up to ${modifierGroup.maxQty} selections` : `Make ${modifierGroup.maxQty} selection`}
                                  </li>
                                  {
                                    modifierGroup.freeQty > 0 &&
                                    <>
                                      <span className="redDot"></span>
                                      <li className="pointThree">Choose any and get {modifierGroup.freeQty} Qty. free</li>
                                    </>
                                  }
                                </ul>
                              ) : null}
                              {modifierGroup.minQty > 0 && modifierItemsSelected >= modifierGroup.minQty ? <RequiredChecked /> : null}
                            </p>
                            <p className="selectedModifierItemListOverview">{this.showSelectedItems(modifierGroup.modifier_items)}</p>
                          </div>
                          <AccordionOpenIcon />
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="required-optional-body">
                            <p>{modifierGroup.tabDetails != null ? modifierGroup.tabDetails : ''}</p>
                            <div key={`inline-${modifierGroup.tabid}`} className="required-optional-items d-flex" style={{ flexWrap: 'wrap' }}>
                              {modifierGroup.modifier_items.map((modifierItem, modifierItemIndex) => {
                                return populateModifierItem(modifierGroup, modifierGroupIndex, modifierItem, modifierItemIndex);
                              })}
                            </div>
                            <button
                              className={`nextAccordionButton ${modifierGroup.minQty > 0 ? (modifierItemsSelected >= modifierGroup.minQty ? '' : 'disabled') : ''}`}
                              onClick={() => this.openNextAccordion(modifierGroupIndex)}
                            >
                              NEXT
                            </button>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    );
                  })}
                </Accordion>
              );
            })()}

            {selectedItem.smartModifiers.length == 0 ? (
              <></>
            ) : (
              <Accordion className="modifierGroupsAccordionWrapper smartModifiersWrap">
                <Accordion.Item className="modifierGroupDiv add-remove-blk" eventKey={`smartModifiers_0`}>
                  <Accordion.Header className="modiferGroupName">
                    Optional&nbsp;
                    <span>
                      (<PiBowlFoodFill className="addAsSideIcon" /> Add as side, <RiCloseCircleFill className="removeIcon" /> Remove)
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="rve-add-blk">
                      <h3 className="modiferGroupName">&nbsp;</h3>
                      <p className="modiferGroupName">Remove</p>
                      <p className="modiferGroupName">Add as Side</p>
                    </div>
                    <div key={`inline-smartMods-div`} className="add-remove-items d-flex" style={{ flexWrap: 'wrap' }}>
                      {selectedItem.smartModifiers.map((smartModifierItem, smartModifierItemIndex) => {
                        return populateModifierItem('', '', smartModifierItem, smartModifierItemIndex);
                      })}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
          </div>

          <div className={`modifierPopupFooter ${calculateItemTotal().itemQty == 0 ? 'visibilityNone' : ''}`}>
            {process.env.REACT_APP_FNB_MODIFIER_QUANTITY_ENABLE == 'true' && (
              <div className="incDecDivForItem">
                <div className="quty">
                  <p>Quantity</p>
                </div>
                <div className="inc-btn-blk">
                  <button type="button" class="btn btn-outline-secondary decButton" onClick={() => incDecItem('subtract', '')}>
                    {/* <img src={decrementIcon} className="dec-img" alt="Decrement" /> */}
                    <DecrementIcon />
                  </button>
                  <button type="button" class="btn btn-outline-secondary itemQty">
                    {selectedItem.selectedQty}
                  </button>
                  <button type="button" class="btn btn-outline-secondary incButton" onClick={() => incDecItem('add', '')}>
                    {/* <img src={incrementIcon} className="inc-img" alt="Increment" /> */}
                    <IncrementIcon />
                  </button>
                </div>
              </div>
            )}
            {checkIfBtnIsDisabled() != 0 ? (
              <div className="makeRequiredSelections">
                <button>
                  {checkIfBtnIsDisabled()} more {checkIfBtnIsDisabled() == 1 ? 'selection' : 'selections'}
                </button>
              </div>
            ) : null}
            {checkIfBtnIsDisabled() == 0 ? (
              <div className="submitButtonPriceDiv">
                <p>${calculateItemTotal().price}</p>
                <button type="button" class={`btn btn-outline-secondary proceedButton ${checkIfBtnIsDisabled() != 0 ? 'disabled' : ''}`} onClick={() => proceedBtnClick()}>
                  Add to Cart
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
